import {Injectable} from '@angular/core';
import {HttpService} from './http-service';
import {Observable} from 'rxjs/Rx';
import {TAction} from "../app/enum";
import {Util} from "../app/util";

@Injectable()
export class SupportService {

    constructor(public http: HttpService, public util: Util) { //public injector: Injector

    }

    assunto(action: TAction): Observable<any> {

        let url = 'SYNC-Assunto?Action=' + TAction[action];

        return this.http.get(url);

    }

    subject(action: TAction, subjectID: number, hotspotID: number = 0, profileID: number = 0, messageID: number = 0, limitPage: number = 0, json: any = null, params: string = ''): Observable<any> {

        let url = 'SYNC-Subject?Action=' + TAction[action] + '&SubjectID=' + subjectID + '&HotspotID=' + hotspotID + '&ProfileID=' + profileID + '&MessageID=' + messageID + '&LimitPage=' + limitPage + params;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }

    mailing(action: TAction, mailingID: number = 0, subjectID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Mailing?Action=' + TAction[action] + '&MailingID=' + mailingID + '&SubjectID=' + subjectID;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }

    message(action: TAction, subjectID: number, json: any = null): Observable<any> {

        let url = 'SYNC-Message?Action=' + TAction[action] + '&SubjectID=' + subjectID;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }

    arquivo(action: TAction, arquivoID: number): Observable<any> {

        let url = 'SYNC-Arquivo?Action=' + TAction[action] + '&ArquivoID=' + arquivoID;

        return this.http.get(url);

    }

}



// WEBPACK FOOTER //
// ./src/providers/support-service.ts